import axios from '@/axiosInstance.ts'
import {AssignmentsSearchParams, TableCountersSearchParams} from '@features/home/types.ts'
import {ResponseType} from '@/types.ts'

/*Get assignments*/
export interface HttpGetAssignmentsOptions {
    params: AssignmentsSearchParams
}
export const httpGetAssignments = ({params}: HttpGetAssignmentsOptions) =>
    axios.get(`/navigate/photographers/home/assignments`, {params})

/*Get required actions*/
export interface HttpGetRequiredActionsOptions {
    params: {
        response_type: ResponseType
    }
}
export const httpGetRequiredActions = ({params}: HttpGetRequiredActionsOptions) =>
    axios.get(`/navigate/photographers/home/actions`, {params})

/*Get required actions*/
export interface HttpGetTableCountOptions {
    params: TableCountersSearchParams
}
export const httpGetTableCount = ({params}: HttpGetTableCountOptions) =>
    axios.get(`/navigate/photographers/home/count`, {params})
